// time format for vue filter `| formatDate`
export default {
  // https://momentjs.com/timezone/docs/#/using-timezones/
  zone: 'America/New_York',
  // https://momentjs.com/docs/#/displaying/format/
  format: 'LL'
}
